import { render } from "./CIS-Benchmark-CIS-CAT-Pro.vue?vue&type=template&id=706bd6b6&scoped=true"
import script from "./CIS-Benchmark-CIS-CAT-Pro.vue?vue&type=script&lang=js"
export * from "./CIS-Benchmark-CIS-CAT-Pro.vue?vue&type=script&lang=js"

import "./CIS-Benchmark-CIS-CAT-Pro.vue?vue&type=style&index=0&id=706bd6b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706bd6b6"]])

export default __exports__